export default {
    exportPDF: function( pdf ) {
        "use strict";
        if ( !!window.chrome ) {
            let blob = pdf.output("blob");
            window.open( URL.createObjectURL( blob ) );
        } else {
            pdf.output( "dataurlnewwindow" );
        }
    }
};
